module.exports = __webpack_public_path__ + "static/media/syncing-data.627499f5.png";